import React, { PureComponent } from 'react'
import { Alert, Button, FormCheck } from 'react-bootstrap'
import { APP_USER, STORAGE_TYPE_LOCAL } from '../../config'
import StorageProviderFactory from '../../managers/storage_provider_factory'
import { formatTimeString } from '../../utils/formatters'

const groups = ['client_admins', 'managers', 'clerks']
const emailRegexp =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

class EditUserComponent extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      first_name: '',
      last_name: '',
      email: '',
      groups: '',
      is_active: false,
      formChanged: false,
      selectedGroup: '',
      resendEmailMessage: '',
      last_login: '',
      date_joined: '',
    }
  }

  currentUser

  changeHandler = ({ target }) => this.setState({ [target.name]: target.value, formChanged: true })

  changeIsActiveHandler = ({ target }) => this.setState({ is_active: target.checked, formChanged: true })

  changeGroupsHandler = ({ target }) => this.setState({ selectedGroup: target.value })

  isPasswordsMatch = () => this.state.password === this.state.confirm_password

  validForm = () => {
    const { state } = this

    const validationResult =
      state.first_name.trim().length &&
      state.last_name.trim().length &&
      state.email.trim().length &&
      this.isValidEmail(state.email.trim())

    return validationResult
  }

  isValidEmail = () => emailRegexp.test(this.state.email)

  componentDidMount() {
    this.currentUser = JSON.parse(StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(APP_USER))
    const { user } = this.props
    if (user) {
      this.setState({
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        groups: user.groups,
        is_active: user.is_active,
        last_login: user.last_login,
        date_joined: user.date_joined,
        selectedGroup: groups.find((g) => g === user.groups),
      })
    }
  }

  onSave = async () => {
    const { props, state } = this
    const user = {
      id: state.id,
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      group: state.selectedGroup,
      is_active: state.is_active,
    }
    this.setState({ formChanged: false })
    props.updateUser(user)
  }

  onResendEmail = async () => {
    const { props } = this
    props.resendEmail(props.user.email)
    this.setState({ resendEmailMessage: 'Welcome email sent!' })
  }

  validationMessage = (name) => {
    const { errors } = this.props
    if (errors && errors[name] && !this.state.formChanged) {
      return (
        <div>
          {errors[name].map((e, index) => (
            <span key={index} className='help-block'>
              {e}
            </span>
          ))}
        </div>
      )
    } else {
      return null
    }
  }

  isEditableGroup = () => this.isClientAdmin()

  isClientAdmin = () =>
    !!(this.currentUser && this.currentUser.groups && this.currentUser.groups.includes('client_admins'))

  render() {
    const { state, props, validationMessage, isEditableGroup, changeGroupsHandler, changeIsActiveHandler } = this
    const { isFetching } = props
    return (
      <form className='form-horizontal'>
        <fieldset>
          {props.errorMessage && !state.formChanged && (
            <div>
              <Alert variant='danger'>{props.errorMessage}</Alert>
              {props.errorDetails &&
                props.errorDetails.length > 0 &&
                props.errorDetails.map((e, index) => (
                  <Alert key={index} variant='danger'>
                    {e}
                  </Alert>
                ))}
            </div>
          )}
          {state.resendEmailMessage && (
            <div>
              <Alert variant='success'>{state.resendEmailMessage}</Alert>
            </div>
          )}
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='email'>
              Email Address
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-envelope-o' />
                </div>
                <input
                  id='email'
                  name='email'
                  type='email'
                  required
                  placeholder='Email Address'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.email}
                />
              </div>
              {validationMessage('email')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='first_name'>
              First Name
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-users' />
                </div>
                <input
                  id='first_name'
                  name='first_name'
                  required
                  placeholder='First Name'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.first_name}
                />
              </div>
              {validationMessage('first_name')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='last_name'>
              Last Name
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-male' />
                </div>
                <input
                  id='last_name'
                  name='last_name'
                  required
                  placeholder='Last Name'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.last_name}
                />
              </div>
              {validationMessage('last_name')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='groups'>
              Groups
            </label>
            <div className='col-md-4'>
              <div className='input-group' style={{ zIndex: '9999' }}>
                <div className='input-group-addon'>
                  <i className='fa fa-user' />
                </div>
                {isEditableGroup() && (
                  <select
                    value={state.selectedGroup}
                    name={'groups'}
                    id={'groups'}
                    className='form-control input-md'
                    onChange={changeGroupsHandler}
                  >
                    <option defaultValue={''} />
                    {groups.map((group, index) => (
                      <option key={index} value={group}>
                        {group}
                      </option>
                    ))}
                  </select>
                )}
                {!isEditableGroup() && (
                  <input
                    name={'groups'}
                    id={'groups'}
                    className='form-control input-md'
                    disabled
                    value={state.groups}
                  />
                )}
              </div>
              {validationMessage('groups')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='date_joined'>
              Date Joined
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-calendar' />
                </div>
                <input
                  disabled
                  id='date_joined'
                  name='date_joined'
                  required
                  className='form-control idnput-md'
                  value={state.date_joined ? formatTimeString(state.date_joined) : ''}
                />
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='last_login'>
              Last Login
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-calendar' />
                </div>
                <input
                  disabled
                  id='last_login'
                  name='last_login'
                  required
                  className='form-control input-md'
                  value={state.last_login ? formatTimeString(state.last_login) : ''}
                />
              </div>
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='is_active'>
              Is Active
            </label>
            <div className='col-md-4'>
              <div className='input-group' style={{ zIndex: '9999' }}>
                <div style={{ marginLeft: 10, textAlign: 'center' }}>
                  <FormCheck
                    id={'is_active'}
                    name={'is_active'}
                    checked={state.is_active}
                    onChange={changeIsActiveHandler}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='form-group'>
            <div className='col-md-12' style={{ textAlign: 'center' }}>
              <div>
                <Button onClick={this.onResendEmail} variant={'default'}>
                  Resend Welcome Email
                </Button>
                &nbsp;
                <Button onClick={props.onCancel} variant={'default'}>
                  Cancel
                </Button>
                &nbsp;
                <Button
                  variant='primary'
                  onClick={this.onSave}
                  disabled={!(this.isPasswordsMatch() && this.validForm())}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    )
  }
}

export default EditUserComponent
